import { i18n } from '@/commons/utils';
import { init as initCustomerCompanyType } from '../customer-company-type';
import { init as initAccountNavigation }  from './account-navigation';
import { init as initCustomerNationalId } from '../customer-national-id';
import { init as initCustomerPassword } from '../customer-password';
import { init as initCustomerNames } from '../customer-names';
import { init as initHeader } from '@/commons/header/header';
import { init as initAccountProfileHomeAddress, reloadHomeAddressForm } from './account-profile-home-address';
import { getParameters, resetForm } from '../customer-utils';


const URL = {
  UPDATE_LOGIN: 'rest/model/atg/userprofiling/ProfileActor/updateLoginInformation-mobileValidation',
  UPDATE_DATA: 'rest/model/atg/userprofiling/ProfileActor/update',
  UPDATE_PASSWORD: 'rest/model/atg/userprofiling/ProfileActor/updatePassword',
  SEND_CODE: 'rest/model/atg/userprofiling/ProfileActor/sendVerificationCodeUpdate',
  UPDATE_COMPANY_DATA: 'rest/model/atg/userprofiling/ProfileActor/updateCompany',
};

let openForms;
let blocks;
let currentBlock;
let counter;

export const init = () => {
  initAccountProfileHomeAddress('address-form');

  openForms = [];
  blocks = cube.$$('.profile-block');

  const forms = cube.$$('.profile-block__form');
  forms.forEach(form => validator(form));

  const editButtons = cube.$$('.edit-button');
  editButtons.on('click', toggleForm);

  const closeButtons = cube.$$('.cancel-button');
  closeButtons.on('click', toggleForm);

  const submitButtons = cube.$$('.submit-button');
  submitButtons.on('click', updateProfile);

  const datepickers = cube.$$('.datepicker');
  if (datepickers.length)
    initDatepicker(datepickers);

  const date = cube.$id('date');
  if (date)
    $(date).on('focusout', updateATGdate);

  const mobileInput = cube.$id('mobile');
  const loginForm = cube.$id('login-form');
  if (mobileInput) {
    loginForm.on('reset', () => showMobileVerification(false));
    mobileInput.on('keyup', showMobileVerification);
  }

  const sendCodeButtons = cube.$$('.send-code-button, .resend-code-button');
  if(sendCodeButtons)
    sendCodeButtons.on('click', sendVerificationCode);

  const emailConfirmation = cube.$id('js-email-confirmation');
  if (emailConfirmation) {
    cube.$$('#email, #js-email-confirmation').on('dragstart', e => e.preventDefault());
    emailConfirmation.on('copy', preventCopyPaste);
    emailConfirmation.on('paste', preventCopyPaste);
  }

  if (cube.$id('company-type')) initCustomerCompanyType();
  if (cube.$id('js-national-id')) initCustomerNationalId();
  if (cube.$id('js-middlename-checkbox')) initCustomerNames();
};


/**
 * Update and format the birthdate for ATG.
 */
function updateATGdate () {
  const formatedDate = cube.$id('date-formated');

  formatedDate.value = this.value
    ? $(this)
      .data('DateTimePicker')
      .date()
      .format(formatedDate.dataset.dateFormat)
    : null;
}


/**
 * Disable copy / paste for email confirmation input and display a custom error if the user try to do it.
 * Email confirmation must be activated.
 *
 * @param {Event} e
 */
function preventCopyPaste (e) {
  e.preventDefault();

  const emailConfirmation = this;
  const validator = $(this.closest('.profile-block__form')).validate();

  const error = {
    [emailConfirmation.id]: e.type === 'copy'
      ? i18n('profile.update.mail.copy.forbidden')
      : i18n('profile.update.mail.paste.forbidden')
  };

  validator.showErrors(error);
}


/**
 * Display or hide the mobile verification button.
 *
 * @param {Boolean} show
 */
function showMobileVerification (show = true) {
  const input = this;
  const currentMobile = cube.$id('original-mobile');

  // if currentMobile doesn't exist, mobile is not an identifier.
  if (!currentMobile) return;

  const send = cube.$id('send-code');
  const mobileVerification = cube.$id('mobile-verification');
  const showBlock = input && $(input).valid() && input.value !== currentMobile.value;

  if (counter)
    counter.stop();

  if (!(show || mobileVerification.classList.contains('hide')))
    mobileVerification.classList.add('hide');

  if (!(show || showBlock))
    send.classList.add('hide');
  else
    send.classList.remove('hide');
}


/**
 * Send a code by SMS and display an input to validate the user mobile.
 * Mobile verification must be activated.
 *
 * @param {Event} e
 */
function sendVerificationCode (e) {
  e.preventDefault();

  const button = this;
  const form = button.closest('.profile-block__form');
  const mobile = form.$('[name=mobile]');
  const mobileCountryCode = form.$('[name=mobileCountryCode]');

  button.disabled = true;

  cube.ajax
    .post(URL.SEND_CODE, {
      mobile: mobile.value,
      mobileCountryCode: mobileCountryCode.value
    })
    .onSuccess(response => {
      if (updateError(response, button))
        return;

      const send = cube.$id('send-code');
      const mobileVerification = cube.$id('mobile-verification');
      counter = new window.decathlon.userAccount.Countdown($(this), 30);

      cube.alert.information(i18n('profile.smsSent'));
      button.disabled = false;
      send.classList.add('hide');
      mobileVerification.classList.remove('hide');

      if (button.classList.contains('resend-code-button'))
        counter.go();
    })
    .onError(response => updateError(response, button))
    .call();
}


/**
 * Initialize bootstrap datepicker.
 *
 * @param {HTMLElement} datepickers every datepicker on the page.
 */
const initDatepicker = datepickers => {
  datepickers.forEach(datepicker => {
    const $datepicker = $(datepicker);
    const { minAge, maxAge } = datepicker.dataset;
    const date = new Date();
    const value = datepicker.value;

    $datepicker
      .datetimepicker({
        minDate: maxAge && new Date(
          date.getFullYear() - maxAge,
          date.getMonth(),
          date.getDate()
        ),
        maxDate: minAge && new Date(
          date.getFullYear() - minAge,
          date.getMonth(),
          date.getDate()
        )
      })
      .val(value);
  });
};


/**
 * Open or close form blocks.
 *
 * @param {Event} e
 */
function toggleForm (e) {
  e.preventDefault();

  const button = this;
  const block = button.closest('.profile-block');
  const { classList } = block;
  const index = [...blocks].indexOf(block);
  const form = block.$('.profile-block__form');

  if (button.classList.contains('edit-button')) {
    classList.remove('profile-block--info');
    classList.add('profile-block--edit');
    openForms.push(index);
  }
  else {
    classList.remove('profile-block--edit');
    classList.add('profile-block--info');
    openForms.splice(openForms.indexOf(index), 1);

    resetForm(form);
  }
}


/**
 * Save the opened blocks and keep them open after a "reload cartridge".
 *
 */
const setOpenBlocks = () => {
  const currentIndex = [...blocks].indexOf(currentBlock);

  openForms.splice(openForms.indexOf(currentIndex), 1);
  openForms.forEach(form => {
    const { classList } = blocks[form];

    classList.remove('profile-block--info');
    classList.add('profile-block--edit');
  });
};


/**
 * Display an error if the XHR returns error(s).
 *
 * @param {Json} response The XHR response.
 * @param {HTMLElement} button The form submit button.
 * @returns {Boolean}
 */
const updateError = (response, button) => {
  if (
    typeof response === 'string' ||
    typeof response === 'object' && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message
  ) {
    if (typeof response === 'string')
      cube.alert.error(i18n('error.oc.call'));
    else
      cube.alert.error(response.responseTO.errors[0].message);

    button.disabled = false;

    return true;
  }

  return false;
};


/**
 * Update the DOM with the new customer data if the XHR returns no error.
 *
 * @param {Json} response The XHR response.
 * @param {Object} params The form parameters formatted in Json.
 * @param {HTMLElement} button The form submit button.
 * @returns
 */
const updateSuccess = (response, params, button) => {
  if (updateError(response, button))
    return;

  cube
    .cartridge('profile-data')
    .after(() => {
      init();
      setOpenBlocks();
      initCustomerNationalId();
      initCustomerPassword();
      if (cube.$id('js-middlename-checkbox')) initCustomerNames();
      cube.alert.success(i18n('profile.changesSaved'));
    })
    .reload(params);

  cube
    .cartridge('header-my-account')
    .after(() => {
      //TODO: remove this function //
      $('#dropdown-account').uxHeaderDropdownFunctions();
      initHeader();
    })
    .reload();

  cube
    .cartridge('dashboard-account-nav')
    .after(initAccountNavigation)
    .reload();
};


/**
 * Use the correct API to update the customer profile.
 *
 * @param {Event} e
 */
function updateProfile (e) {
  e.preventDefault();

  const button = this;
  const block = button.closest('.profile-block');
  const form = block.$('.profile-block__form');

  currentBlock = block;

  if ($(form).valid()) {
    const params = getParameters(form);
    const urlMap = {
      'login-form': URL.UPDATE_LOGIN,
      'password-form': URL.UPDATE_PASSWORD,
      'company-form': URL.UPDATE_COMPANY_DATA,
      'data-form': URL.UPDATE_DATA
    };

    button.disabled = true;

    // Specific for address form component //
    if (form.id === 'address-form') {
      reloadHomeAddressForm(form, () => {
        const address = cube.$id('address');

        address.$('.edit-button').on('click', toggleForm);
        address.$('.cancel-button').on('click', toggleForm);
        address.$('.submit-button').on('click', updateProfile);
        button.disabled = false;
      });

      return;
    }

    const url = urlMap[form.id];

    cube.ajax
      .post(url, params)
      .onSuccess(response => updateSuccess(response, params, button))
      .onError(response => updateError(response, button))
      .call();
  }
}

const validator = form => {
  $(form).validate(Object.assign(
    $.validator.cubeOptions,
    {
      rules: {
        mobile : { mobile: true },
        landline : { mobile: true },
        'email-confirmation': { equalTo: '#email' },
        actualPassword: { minlength: 6 },
        password: { passwordCheck: true },
        firstName: { extendedalphanumeric: true },
        lastName: { extendedalphanumeric: true },
        middleName: { extendedalphanumeric: true },
        confirmPassword: { equalTo: '#password' },
        companyName: { extendedalphanumeric: true }
      },

      messages: {
        actualPassword: {
          minlength: i18n('profile.updatePassword.newpassword.minLength'),
          required: i18n('profile.updatePassword.actualPassword.required'),
        },
        password: {
          required: i18n('profile.updatePassword.newpassword.required'),
          minlength: i18n('profile.updatePassword.newpassword.minLength'),
        },
        confirmPassword: {
          required: i18n('profile.updatePassword.confirmPassword.required'),
          minlength: i18n('profile.updatePassword.newpassword.minLength'),
          equalTo: i18n('profile.updatePassword.confirmPassword.equalsTo'),
        }
      },

      ignore: ':hidden:not(.selectpicker)',

      unhighlight: (element, error, valid) => {
        const parent = element.closest('.form-group');
        const { classList } = parent;

        classList.remove(error);

        if (element.value.length && element.name !== 'actualPassword') {
          classList.add(valid);
        }
        else {
          classList.remove(valid);
          classList.remove(error);
        }
      }
    }
  ));
};



// WEBPACK FOOTER //
// ./src/customer/account/account-profile.js